import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import type { ProjectDto } from '@fiverr-private/book_publishing_types';
import { handleNotFoundError } from '../../utils/handleNotFoundError';

export const fetchActiveProject = async (baseUrl: string): Promise<ProjectDto | null> => {
    try {
        const url = `${baseUrl}/api/v1/book-publishing/projects/activeProject`;
        const response = await axios.get<ProjectDto>(url).catch(handleNotFoundError);

        return response?.data ?? null;
    } catch (error: any) {
        logger.error(error, { description: 'Failed to fetch active book publishing project' });
        throw error;
    }
};
